<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('score')"
      prop="scoreID"
      :rules="getValidationRule('required')"
      class="material-style">
      <select-response
        :model.sync="form.scoreID"
        :fields="{id: 'id', title: 'scoreText'}"
        :data="dataSourceScore.records"
        :isLoading="dataSourceScore.loading"
      ></select-response>
    </el-form-item>
    <el-form-item
      v-if="showPoOpen"
      prop="poStillOpen"
      class="material-style"
    >
      <el-checkbox
        v-model="form.poStillOpen"
      >
        {{L10n('po-still-open')}}
      </el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormActivityPoWoWrap',
  mixins: [Form],
  props: {
    showPoOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText&filter=scoreIndex==3&orderBy=scoreText')
    }
  }
}
</script>
